import { HttpParams } from '@angular/common/http';
import { GetDepartmentsLookupValue } from './get-departments-lookup.value';

export class GetDepartmentsLookupValueDto {
    roleId?: string;

    constructor(data: GetDepartmentsLookupValue) {
        this.roleId = data.roleId;
    }

    toHttpParams(): HttpParams {
        let params = new HttpParams();

        if (this.roleId) {
            params = params.set('roleId', this.roleId);
        }

        return params;
    }
}
